import React from 'react'
import PropTypes from 'prop-types'
import DownloadLinksContainer from './DownloadLinksContainer'

const dropdown = () => {
  const timeframes = [
    ['1', '1 month'],
    ['3', '3 months'],
    ['6', '6 months'],
    ['12', '1 year'],
    ['24', '2 years'],
    ['0', 'All Data'],
  ]
  const options = []
  for (var i = 0; i < timeframes.length; i++) {
    options.push(
      <option value={timeframes[i][0]} key={i}>
        {timeframes[i][1]}
      </option>
    )
  }
  return options
}

export default class TimeframeDropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectedValue: '3' }
  }
  handleChange = e => {
    this.setState({ selectedValue: e.target.value })
  }

  render() {
    return (
      <div className="intro_box">
        <div className="intro_box_inner">
          <p>
            If you would like to calculate more detailed or different analytics
            for your students, download the source data via the following links.
            These downloads can be opened in a spreadsheet application or
            imported into a statistical package.
          </p>
          <div>
            <select
              className="mb-4"
              value={this.state.selectedValue}
              onChange={e => this.handleChange(e)}
            >
              {dropdown()}
            </select>
            <DownloadLinksContainer
              coursenum={this.props.coursenum}
              timeframe={this.state.selectedValue}
            />
          </div>
        </div>
      </div>
    )
  }
}

TimeframeDropdown.propTypes = {
  coursenum: PropTypes.string.isRequired,
}
